<template>
    <section class="auth-page">

        <div>

        </div>

        <form @submit.prevent="submitForm" type="POST" class="auth-page--form">
            <img class="auth-page--logo" src="@/assets/logo_dark.png" alt="XMLShopconnector" />

            <h3>{{ t('auth.forgot_password') }}</h3>
            <p>{{ t('auth.forgot_password.explanation') }}</p>

            <input
                type="email"
                v-model="email"
                id="email"
                :placeholder="$translate.text('general.email')"
            />

            <button type="submit" class="button button--rounded">{{ t('auth.send_password') }}</button>
        </form>

        <router-link class="bold" :to="{ name: 'Login' }">&larr; {{ t('auth.back_to_login') }}</router-link>
    </section>
</template>
<script>
import axios from 'axios';
import swal from 'sweetalert';

import handleError from '@/helpers/error';

export default {
    name: 'ForgotPasswordPage',

    data() {
        return {
            email: '',
        };
    },

    methods: {
        submitForm() {
            NProgress.start();

            axios({
                method: 'POST',
                url: `${this.$API_URL}/api/auth/password/email`,
                data: {
                    email: this.email,
                    url: `${this.$FRONTEND_URL}/reset-password`,
                },
            })
                .then(() => {
                    NProgress.done();
                    swal(this.$translate.text('auth.forgot_password.ok'))
                        .then(() => {
                            this.$router.push('/login');
                        });
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('auth.forgot_password.error'),
                    });
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.auth-page {
    width: 100%;
    min-height: 100vh;
    background-color: $bluegrey;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    &--logo {
        width: 100%;
        height: auto;
        max-width: 400px;
        margin-bottom: 48px;
    }

    &--form {
        padding: 20px;
        display: flex;
        flex-direction: column;
        width: 400px;

        input {
            margin-bottom: 8px;
            border: 0;
            border-radius: 4px;
            height: 40px;
            text-align: center;
            font-size: 16px;
        }

        button {
            margin-top: 16px;
        }

        h3, p {
            text-align: center;
        }

        h3 {
            font-size: 32px;
            margin-bottom: 16px;
        }

        p {
            margin-bottom: 16px;
        }
    }

    a {
        margin-bottom: 24px;
        color: $blue;
        text-decoration: none;

        &:hover {
            color: darken($blue, 10%);
        }
    }
}
</style>
